import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral from 'numeral';
import Cleave from 'cleave.js/react';
import 'react-select/dist/react-select.css';

import Page from '../components/Page';
// import GoodsTable from '../components/GoodsTable';
import GoodList from '../components/GoodList';
import SearchableSelect from '../components/SearchableSelect';
import BuyQuote from '../components/BuyQuote';

import Config from '../utils/config';
import LocalDB from '../utils/localDB';
import { removeGood, editRemoveGood } from '../utils/good-utils';
//import Utils from '../utils/mci-utils';

import { translations } from '../i18n/translations';

import {
  listCountries,
  listCurrencies,
  listDestinationTowns,
  listDestinationPorts,
  listGoodsSections,
  listGoods
} from '../actions/policy';
//import { fetchComparisonOtherRates } from '../actions/rates';
import { listBrokers, listAgencies } from '../actions/brokers';
import { fetchCurrencyRate } from '../actions/currencies';

import SimpleReactValidator from 'simple-react-validator';

class Quote extends Component {
  constructor(props) {
    super(props);

    this.goodsValidator = new SimpleReactValidator();
    this.qouteValidator = new SimpleReactValidator();
    this.state = {
      selectedGood: {
        cfr: 0,
        description: '',
        quantity: '',
        section: '',
        unit_qty: ''
      },
      quote: {
        icc_class: 'ICC-A',
        transaction_type: Config.TRANSACTION_TYPE.IMPORT,
        packaging: 'CONTAINERISED',
        origin: {
          id: ''
        },
        destination: {},
        selected_broker: { id: '', name: '' },
        selected_agency: { id: '', name: '' },
        entry_port: Config.DEFAULT_PORT_OF_ENTRY,
        shipment: '',
        currency_rate: {
          id: '6a8a8d56-a0a9-4944-b41d-ca5644676ebf',
          currency: '345eaac7-5f2a-460f-99ac-03fff84e4ebb',
          currency_code: 'TZS',
          currency_name: 'Tanzanian Shilling',
          currency_symbol: 'TSh',
          rate: '1.0000',
          effective_date: '2017-08-29',
          date: '2017-08-29',
          status: true,
          created_by: null
        },
        conveyance: Config.CONVEYANCE.SEA,
        selected_goods: [],
        good: {}
      },
      show_goods_form: false
    };
  }

  componentWillMount() {
    LocalDB.flush();
  }

  componentDidMount() {
    const {
      listCountries,
      listCurrencies,
      listDestinationTowns,
      listDestinationPorts,
      listBrokers,
      listAgencies,
      listGoodsSections
    } = this.props;

    listCountries();
    listCurrencies();
    listDestinationTowns();
    listDestinationPorts(this.state.quote.conveyance);

    listBrokers();
    listAgencies();

    listGoodsSections();
  }

  componentWillReceiveProps(nextProps) {
    const { quote } = this.state;
    const { currency, policy, goods } = nextProps;

    const ports = policy.destinationPorts;

    /* Set default values from updated state */
    this.setState({
      quote: {
        ...quote,
        entry_port: {
          id: ports.length > 0 ? ports[0].id : '',
          port: ports.length > 0 ? ports[0].name : ''
        },
        currency_rate: currency.currencyRate || {},
        selected_goods: goods.goods
      }
    });
  }

  onChange = e => {
    const { quote } = this.state;
    const { name, value } = e.target;

    this.setState({
      quote: {
        ...quote,
        [name]: value
      }
    });
  };

  onSelectChange = e => {
    const { quote } = this.state;
    const { selectedIndex, value, options, name } = e.target;

    this.setState({
      quote: {
        ...quote,
        [name]: {
          id: value,
          name: options[selectedIndex].text
        }
      }
    });
  };

  handleConveyance = e => {
    const { quote } = this.state;
    const { name, value } = e.target;

    this.setState({
      quote: {
        ...quote,
        [name]: value
      }
    });

    this.props.listDestinationPorts(value);
  };

  handlePortOfEntry = e => {
    const { quote } = this.state;
    const { selectedIndex, value, options } = e.target;

    this.setState({
      quote: {
        ...quote,
        entry_port: {
          id: value,
          port: options[selectedIndex].text
        }
      }
    });
  };

  handleImportationCurrency = e => {
    const { quote } = this.state;
    const currency = e.target.value;

    if (currency !== '') {
      this.props.fetchCurrencyRate(currency);
    } else {
      this.setState({
        quote: {
          ...quote,
          currency_rate: {}
        }
      });
    }
  };

  handleBrokers = e => {
    const { options, value, selectedIndex } = e.target;
    const { quote } = this.state;

    this.setState({
      quote: {
        ...quote,
        selected_broker: {
          id: value,
          name: options[selectedIndex].text
        }
      }
    });
  };

  handleAgencies = e => {
    const { quote } = this.state;
    const { options, value, selectedIndex } = e.target;

    this.setState({
      quote: {
        ...quote,
        selected_agency: {
          id: value,
          name: options[selectedIndex].text
        }
      }
    });
  };

  handleOrigin = e => {
    const { quote } = this.state;
    const { options, value, selectedIndex } = e.target;

    this.setState({
      quote: {
        ...quote,
        origin: {
          id: value,
          country: options[selectedIndex].text
        }
      }
    });
  };

  handleDestination = e => {
    const { quote } = this.state;
    const { options, value, selectedIndex } = e.target;

    this.setState({
      quote: {
        ...quote,
        destination: {
          id: value,
          town: options[selectedIndex].text
        }
      }
    });
  };

  onSelectGoodInputChange = e => {
    e.preventDefault();
    const { selectedGood } = this.state;
    const { options, value, selectedIndex } = e.target;

    this.setState({
      selectedGood: {
        ...selectedGood,
        section: value,
        section_name: options[selectedIndex].text
      }
    });
  };

  onGoodInputChange = e => {
    e.preventDefault();
    const { selectedGood } = this.state;
    const { name, value } = e.target;

    this.setState({
      selectedGood: {
        ...selectedGood,
        [name]: value
      }
    });
  };

  // handleGoodAddition_ = (e) =>{
  //     e.preventDefault();
  //     const { quote } = this.state;

  //     let new_goods_list = addGood(quote.selected_goods);

  //     if(new_goods_list !== false){

  //         this.setState({
  //             quote: {
  //                 ...quote,
  //                 selected_goods: new_goods_list
  //             },
  //             show_goods_form: false

  //         }, ()=>{
  //             LocalDB.insert("mci_form", this.state.quote)
  //         });
  //     }
  // }

  onAddGood = e => {
    e.preventDefault();

    const { selectedGood, quote } = this.state;
    //const prevState = this.state.quote;

    const selectedGoods = quote.selected_goods;
    if (this.goodsValidator.allValid()) {
      this.goodsValidator.hideMessages();
      selectedGoods.push(selectedGood);
    } else {
      this.goodsValidator.showMessages();
      // rerender to show messages for the first time
      this.forceUpdate();
    }

    this.setState({
      quote: {
        ...quote,
        selected_goods: selectedGoods
      },
      selectedGood: {
        section_name: '',
        section: '',
        cfr: 0,
        quantity: '',
        unit_qty: '',
        description: ''
      }
    });
  };

  removeGood = good => {
    const selected_goods = editRemoveGood(
      this.state.quote.selected_goods,
      good
    );
    this.setState({
      quote: {
        ...this.state.quote,
        selected_goods: selected_goods
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.qouteValidator.allValid()) {
      this.qouteValidator.hideMessages();
      //handle submit here
      LocalDB.insert('mci_form', this.state.quote);
      this.props.history.push('/compare');
    } else {
      this.qouteValidator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const {
      countries,
      currencies,
      destinationTowns,
      destinationPorts,
      goodsSections
    } =
      this.props.policy || {};
    const { brokers, agencies } = this.props.brokers || {};

    const {
      importation_currency,
      currency_rate,
      origin,
      destination,
      entry_port,

      selected_broker,
      selected_agency
    } = this.state.quote;
    const { user } = this.props;
    const userRole =
      user.userInfo && user.userInfo.roles ? user.userInfo.roles : '';

    return (
      <Page pageTitle={translations.buyMCI} noPageHeader={true}>
        <div className="clearfix card quote-form">
          <form
            id="quote-form"
            className="form-horizontal col-md-11"
            onSubmit={this.handleSubmit}
          >
            <div className="form-group">
              <label className="col-sm-4 control-label">
                {translations.shipment}
              </label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <label className="radio-inline">
                    <input
                      id="radio-1"
                      type="radio"
                      name="transaction_type"
                      value={Config.TRANSACTION_TYPE.IMPORT}
                      onChange={this.onChange}
                      defaultChecked
                    />
                    {translations.import}
                  </label>
                  <label className="radio-inline">
                    <input
                      id="radio-2"
                      type="radio"
                      name="transaction_type"
                      value={Config.TRANSACTION_TYPE.EXPORT}
                      onChange={this.onChange}
                    />
                    {translations.export}
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">
                {translations.icc}
              </label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <label className="radio-inline">
                    <input
                      id="radio-3"
                      type="radio"
                      name="icc_class"
                      value="ICC-A"
                      onChange={this.onChange}
                      defaultChecked
                    />
                    ICC A
                  </label>
                  <label className="radio-inline">
                    <input
                      id="radio-4"
                      type="radio"
                      name="icc_class"
                      value="ICC-B"
                      onChange={this.onChange}
                    />
                    ICC B
                  </label>
                  <label className="radio-inline">
                    <input
                      id="radio-5"
                      type="radio"
                      name="icc_class"
                      value="ICC-C"
                      onChange={this.onChange}
                    />
                    ICC C
                  </label>

                  <span className="tooltip" title="ICC Details">
                    [? What's this]
                  </span>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">
                {translations.packaging}
              </label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <label className="radio-inline">
                    <input
                      id="radio-6"
                      type="radio"
                      name="packaging"
                      value="CONTAINERISED"
                      onChange={this.onChange}
                      defaultChecked
                    />
                    {translations.containerised}
                  </label>
                  <label className="radio-inline">
                    <input
                      id="radio-7"
                      type="radio"
                      name="packaging"
                      value="NON_CONTAINERISED"
                      onChange={this.onChange}
                    />
                    {translations.non_containerised}
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">
                {translations.choose_currency}
              </label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <div className="input-group col-sm-12">
                    <select
                      id="importation_currency"
                      name="importation_currency"
                      className="form-control"
                      value={importation_currency}
                      onChange={this.handleImportationCurrency}
                    >
                      <option value="">{translations.select_currency}</option>
                      {currencies &&
                        currencies.map((currency, index) => {
                          return (
                            <option key={index} value={currency.id}>
                              {currency.code + ' - ' + currency.name}
                            </option>
                          );
                        })}
                    </select>
                    <span className="input-group-addon">
                      {numeral(currency_rate.rate).format('0,0.00') || '0.00'}
                    </span>
                  </div>

                  {this.qouteValidator.message(
                    'importation_currency',
                    currency_rate.rate,
                    'required',
                    'text-danger'
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">
                {translations.conveyance}
              </label>
              <div className="col-sm-8">
                <label className="radio-inline">
                  <input
                    id="radio-8"
                    type="radio"
                    name="conveyance"
                    value={Config.CONVEYANCE.SEA}
                    onChange={this.handleConveyance}
                    defaultChecked
                  />
                  {translations.sea}
                </label>

                <label className="radio-inline">
                  <input
                    id="radio-9"
                    type="radio"
                    name="conveyance"
                    value={Config.CONVEYANCE.AIR}
                    onChange={this.handleConveyance}
                  />
                  {translations.air}
                </label>

                <label className="radio-inline">
                  <input
                    id="radio-10"
                    type="radio"
                    name="conveyance"
                    value={Config.CONVEYANCE.ROAD}
                    onChange={this.handleConveyance}
                  />
                  {translations.road}
                </label>

                <label className="radio-inline">
                  <input
                    id="radio-11"
                    type="radio"
                    name="conveyance"
                    value={Config.CONVEYANCE.RAIL}
                    onChange={this.handleConveyance}
                  />
                  {translations.rail}
                </label>

                <div className="form-dual">
                  <div className="col-sm-6">
                    {this.state.quote.transaction_type === 'EXPORT' ? (
                      <select
                        id="origin"
                        name="origin"
                        className="form-control"
                        onChange={this.handleOrigin}
                      >
                        <option value=""> - {'Port of Origin'} -</option>
                        {destinationTowns &&
                          destinationTowns.map((town, index) => {
                            return (
                              <option key={index} value={town.id}>
                                {town.name}
                              </option>
                            );
                          })}
                      </select>
                    ) : (
                      <select
                        id="origin"
                        name="origin"
                        className="form-control"
                        onChange={this.handleOrigin}
                      >
                        <option value="">
                          - {translations.country_of_origin} -
                        </option>
                        {countries &&
                          countries.map((country, index) => {
                            return (
                              <option key={index} value={country.id}>
                                {country.name}
                              </option>
                            );
                          })}
                      </select>
                    )}
                    {this.qouteValidator.message(
                      'origin',
                      origin.id,
                      'required',
                      'text-danger'
                    )}
                  </div>

                  <div className="col-sm-6">
                    {this.state.quote.transaction_type === 'EXPORT' ? (
                      <select
                        id="destination"
                        name="destination"
                        className="form-control"
                        onChange={this.handleDestination}
                      >
                        <option value="">
                          - {translations.destination_town} -
                        </option>
                        {countries &&
                          countries.map((country, index) => {
                            return (
                              <option key={index} value={country.id}>
                                {country.name}
                              </option>
                            );
                          })}
                      </select>
                    ) : (
                      <select
                        id="destination"
                        name="destination"
                        className="form-control"
                        onChange={this.handleDestination}
                      >
                        <option value="">
                          {' '}
                          - {translations.destination_town} -
                        </option>
                        {destinationTowns &&
                          destinationTowns.map((town, index) => {
                            return (
                              <option key={index} value={town.id}>
                                {town.name}
                              </option>
                            );
                          })}
                      </select>
                    )}
                    {this.qouteValidator.message(
                      'destination',
                      destination.id,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">
                {this.state.quote.transaction_type === 'EXPORT'
                  ? 'Port of Origin'
                  : translations.port_of_entry}
              </label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <select
                    id="entry_port"
                    name="entry_port"
                    className="form-control"
                    onChange={this.handlePortOfEntry}
                  >
                    <option value="" disabled>
                      - {translations.port_of_entry} -
                    </option>
                    {destinationPorts &&
                      destinationPorts.map((port, index) => {
                        return (
                          <option key={index} value={port.id}>
                            {port.name}
                          </option>
                        );
                      })}
                  </select>
                  {entry_port === '' ? (
                    <div className="text-danger">{translations.hint_port}</div>
                  ) : null}
                </div>
              </div>
            </div>

            <BuyQuote
              userRole={userRole}
              onChangeBrokers={this.handleBrokers}
              onchangeAgencies={this.handleAgencies}
              disabledBrokers={selected_agency.id === '' ? false : true}
              disabledAgencies={selected_broker.id === '' ? false : true}
            />

            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <div className="clearfix goods-form">
                  <span>
                    <div className="col-sm-12">
                      {this.goodsValidator.message(
                        'section',
                        this.state.selectedGood.section,
                        'required',
                        'text-danger'
                      )}
                      <SearchableSelect
                        className="form-control"
                        name="section"
                        value={
                          this.state.selectedGood.section
                            ? this.state.selectedGood.section
                            : undefined
                        }
                        onChange={this.onSelectGoodInputChange}
                      >
                        <option value="">{translations.select_goods}</option>
                        {goodsSections &&
                          goodsSections.map(section => {
                            return (
                              <option key={section.id} value={section.id}>
                                {section.name}
                              </option>
                            );
                          })}
                      </SearchableSelect>
                    </div>
                    <div className="col-sm-12">
                      <textarea
                        id="description"
                        name="description"
                        value={this.state.selectedGood.description}
                        className="form-control"
                        rows="4"
                        placeholder="Describe your goods"
                        onChange={this.onGoodInputChange}
                      />
                      {this.goodsValidator.message(
                        'unit_qty',
                        this.state.selectedGood.unit_qty,
                        'required',
                        'text-danger'
                      )}{' '}
                      {this.goodsValidator.message(
                        'quantity',
                        this.state.selectedGood.quantity,
                        'required',
                        'text-danger'
                      )}
                      <div className="input-group input-group-select">
                        <span className="input-group-addon">
                          <select
                            name="unit_qty"
                            value={this.state.selectedGood.unit_qty}
                            className="form-control"
                            onChange={this.onGoodInputChange}
                          >
                            <option value="">- Unit of Measure -</option>
                            <option value="UNIT">UNIT</option>
                            <option value="KGS">KGS</option>
                            <option value="LITRES">LITRES</option>
                          </select>
                        </span>

                        <Cleave
                          className="form-control"
                          placeholder="Enter Quantity"
                          name="quantity"
                          value={this.state.selectedGood.quantity}
                          options={{
                            numeral: true,
                            numeralThousandsGroupStyle: 'thousand'
                          }}
                          onChange={this.onGoodInputChange}
                        />
                      </div>
                      <div className="input-group">
                        {this.goodsValidator.message(
                          'cfr',
                          this.state.selectedGood.cfr,
                          'required',
                          'text-danger'
                        )}
                        <span className="input-group-addon">
                          {this.props.currency
                            ? this.props.currency.currencyRate.currency_code
                            : ''}
                        </span>

                        <Cleave
                          className="form-control"
                          placeholder={translations.enter_value_of_goods}
                          name="cfr"
                          value={this.state.selectedGood.cfr}
                          options={{
                            numeral: true,
                            numeralThousandsGroupStyle: 'thousand'
                          }}
                          onChange={this.onGoodInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <button
                        style={{ marginRight: '1em' }}
                        className="btn btn-xs btn-success"
                        onClick={this.onAddGood}
                      >
                        <span className="glyphicon glyphicon-plus" />
                        {translations.add}
                      </button>

                      <span
                        className="btn btn-sm btn-danger"
                        onClick={this.toggleAddGoods}
                      >
                        <span className="glyphicon glyphicon-remove" />
                        {translations.cancel}
                      </span>
                    </div>
                  </span>
                </div>

                <GoodList
                  goods={this.state.quote.selected_goods}
                  currency={this.state.quote.currency_rate}
                  removeGoodsFn={this.removeGood}
                />
              </div>
            </div>

            <div className="form-group">
              <label
                className="col-sm-4 control-label"
                htmlFor="singlebutton"
              />
              <div className="col-sm-4">
                <button
                  id="btn"
                  onClick={this.handleSubmit}
                  className="btn btn-primary"
                >
                  <span className="glyphicon glyphicon-ok" />
                  {translations.get_a_quote}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  brokers: state.brokers,
  currency: state.currency,
  goods: state.goods,
  policy: state.policy,
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      listCountries,
      listCurrencies,
      listDestinationTowns,
      listDestinationPorts,
      listBrokers,
      listAgencies,
      fetchCurrencyRate,
      listGoodsSections,
      listGoods
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Quote);



// WEBPACK FOOTER //
// ./src/pages/Quote.js